import type { Colors, DefaultTheme } from 'styled-components';
import { lightColors, mapLightTheme } from './LightTheme';

const colors: Colors = {
  ...lightColors,
  primary: {
    lighten: '#0659ff',
    default: '#0046d2',
    dim: 'rgba(0,70,210,0.4)',
    mute: 'rgba(0,70,210,0.1)',
  },
  gray: {
    '100': '#1d1d28',
    '000': '#e6e6e7',
    '010': '#f2f2f3',
    main: '#ffffff',
    '020': '#fafafa',
    '030': '#ebebeb',
    '040': '#dbdbdd',
    '050': '#d2d2d4',
    '060': '#c8c8ca',
    '070': '#bbbbbe',
    '080': '#9b9b9f',
    '090': '#696970',
  },
  green: {
    lighten: '#12d944',
    default: '#0eaa35',
    dim: 'rgba(14,170,53,0.4)',
    mute: 'rgba(14,170,53,0.1)',
  },
  red: {
    lighten: '#f52323',
    default: '#db0a0a',
    dim: 'rgba(219,10,10,0.4)',
    mute: 'rgba(219,10,10,0.1)',
  },
  yellow: {
    lighten: '#fb3',
    default: '#ffaa00',
    dim: 'rgba(255,170,0,0.4)',
    mute: 'rgba(255,170,0,0.1)',
  },
  orange: {
    lighten: '#0659ff',
    default: '#0046d2',
    dim: 'rgba(0,70,210,0.4)',
    mute: 'rgba(0,70,210,0.1)',
  },
  blue: {
    lighten: '#5fa2e7',
    default: '#3388E0',
    dim: 'rgba(51,136,224,0.4)',
    mute: 'rgba(51,136,224,0.1)',
  },
  purple: {
    lighten: '#9f73d7',
    default: '#844BCC',
  },
  white: {
    default: '#ffffff',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#151516',
    dim: 'rgba(21,21,22,0.4)',
    mute: 'rgba(21,21,22,0.1)',
  },
};

export const LightPrometheumTheme: DefaultTheme = mapLightTheme(colors, {
  name: 'LightProm',

  backgroundChartUpColor: colors.green.lighten,
  backgroundChartDownColor: colors.red.lighten,
  borderColorChartUpColor: colors.green.lighten,
  borderColorChartDownColor: colors.red.lighten,

  colorTextDefaultButton: '#151516',
  colorTextDefaultButtonHover: '#151516',
  colorTextDefaultButtonFocus: '#151516',
  colorTextDefaultButtonActive: '#151516',
  colorTextDefaultButtonDisabled: 'rgba(21,21,22,0.5)',

  colorTextPositiveButton: '#151516',
  colorTextPositiveButtonHover: '#151516',
  colorTextPositiveButtonFocus: '#151516',
  colorTextPositiveButtonActive: '#151516',
  colorTextPositiveButtonDisabled: 'rgba(21,21,22,0.5)',

  colorTextWarningButton: '#151516',
  colorTextWarningButtonHover: '#151516',
  colorTextWarningButtonFocus: '#151516',
  colorTextWarningButtonActive: '#151516',
  colorTextWarningButtonDisabled: 'rgba(21,21,22,0.5)',

  colorTextMutedButton: '#151516',
  colorTextMutedButtonHover: '#151516',
  colorTextMutedButtonFocus: '#151516',
  colorTextMutedButtonActive: '#151516',
  colorTextMutedButtonDisabled: 'rgba(21,21,22,0.5)',
});
